import { localeToISO639Code } from "lib/i18n/localeToISO639Code";
import { CardioExerciseDuration } from "lib/questionnaire/question-flows/onboarding/questions/cardioExercise";
import { Trans as TransQuestions } from "lib/questionnaire/question-flows/onboarding/questions/trans";
import { useLocale } from "render/context/InternationalizationContext";
import { ChoiceInput } from "render/ui/presentation/Questionnaire/components/ChoiceInput";
import { QuestionView } from "../../components/QuestionView";
import { Step, StepProps } from "../../step";
import { Trans } from "../../trans";

function CardioExerciseDurationStep({
  answers,
  onAnswer,
  onNext,
  onPrev,
  currentQuestion,
  totalQuestions,
  onResetAnswer,
}: StepProps) {
  const answer = answers.get(CardioExerciseDuration);
  const label = TransQuestions.CardioExercise.Question();
  const { englishLabel } = TransQuestions.CardioExercise.Question;
  const locale = useLocale();
  const languageCode = localeToISO639Code(locale);

  return (
    <QuestionView
      currentQuestion={currentQuestion}
      totalQuestionCount={totalQuestions}
      question={CardioExerciseDuration}
      onNext={() => {
        onResetAnswer(CardioExerciseDuration);
        onNext();
      }}
      onPrev={() => {
        onPrev();
        onResetAnswer(CardioExerciseDuration);
      }}
      explanation={{
        openText: <Trans.General.WhatCounts />,
        closeText: <Trans.General.OkIUnderstand />,
        explanationText: <Trans.Steps.CardioExerciseExplanation />,
      }}
    >
      <ChoiceInput
        question={CardioExerciseDuration}
        answer={answer}
        onAnswer={(answer) => {
          onAnswer(CardioExerciseDuration, {
            answer,
            questionAnswer: {
              questionId: "weeklyCardioExerciseHours",
              englishLabel,
              label,
              languageCode,
              answer: {
                $type: "stringenum",
                value: CardioExerciseDuration.getValue(answer) || "",
              },
            },
          });
          onNext();
        }}
      />
    </QuestionView>
  );
}

export function filter(steps: Step[]) {
  steps.push(CardioExerciseDurationStep);
}
